<template>
  <v-card v-if="routesLoaded">
    <v-card-title class="title">
      Page Not Found
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-icon>mdi-file-cancel</v-icon>
      Sorry, this isn't the page you are looking for.  Please refresh and try again.
    </v-card-text>
  </v-card>
  <div v-else />
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    routesLoaded () {
      // Don't show 404/NotFound page unless our menus have been fully loaded
      return this.$store.getters.menu.updated
    }
  }
}
</script>

<style>

</style>
